import { render, staticRenderFns } from "./NotificacaoEnvio.vue?vue&type=template&id=c8867656"
import script from "./NotificacaoEnvio.vue?vue&type=script&lang=js"
export * from "./NotificacaoEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports